module.exports = __webpack_public_path__ + "static/img/WarmSend1.d864e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WarmSend1.png
// module id = 8R0I
// module chunks = 0